import { Component, OnInit, inject } from '@angular/core';
import { ApplicationService } from '@/app/application.service';
import { PlatformModeService } from '@/app/platform/platform-core/platform-mode/platform-mode.service';

@Component({
    selector: 'login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.css'],
    standalone: false
})
export class LoginPageComponent implements OnInit {
  constructor(readonly appService: ApplicationService) {}

  readonly platformMode = inject(PlatformModeService);

  ngOnInit(): void {
    // Anoniem: wie hier staat, heeft (nog) geen hubverbinding die de modus doorgeeft
    void this.platformMode.load();
  }

  userName = '';

  onAfterLogin() {}
}
